module.exports = __webpack_public_path__ + "img/portfolio-11-480x274.5c525811.jpg";